import { Company } from "@/common/types";
import SearchVendorByName from "../Vendor/SearchVendorByName/SearchVendorByName";
import { Button, message } from "antd";
import { useModal } from "@/common/contexts/Modal.context";
import { useState } from "react";
import { useChangeVendor } from "@/common/api/mutation";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import CustomTypography from "../Typography/CustomTypography";

export default function ChangeVendorModal({
  vendor,
  quoteId,
}: {
  vendor: Company | null;
  quoteId: number;
}) {
  const navigate = useNavigate();
  const { closeModal } = useModal();
  const [pickedVendor, setPickedVendor] = useState<number>(0);
  const { mutate } = useChangeVendor();
  const pickVendor = (data: any) => {
    setPickedVendor(data.value);
  };
  const submitVendorChanges = () => {
    if (pickedVendor <= 0) {
      return message.error("Pick vendor from list");
    }
    mutate(
      { quoteId, vendorId: pickedVendor },
      {
        onSuccess: () => {
          toast.success("Vendor changed successfully");
          closeModal();
          navigate("/quotes");
        },
      }
    );
  };
  return (
    <div className="min-w-[367px]">
      <CustomTypography
        as="p"
        size={"21px"}
        weight={"semibold"}
        className="text-center mb-4"
      >
        Change Vendor
      </CustomTypography>
      <CustomTypography
        as="p"
        className="mb-4"
        size={"base"}
        weight={"semibold"}
      >
        Current Vendor: {vendor && vendor.companyName}
      </CustomTypography>
      <SearchVendorByName func={pickVendor} />
      <div className="flex justify-between mt-5">
        <Button
          onClick={() => closeModal()}
          type="text"
          className="h-10 font-inter text-base font-semibold border border-primary text-primary hover:!text-primary"
        >
          Close
        </Button>
        <Button
          onClick={submitVendorChanges}
          type="primary"
          className="h-10 font-inter text-base font-semibold"
        >
          Save
        </Button>
      </div>
    </div>
  );
}
